document.addEventListener('DOMContentLoaded', function () {
    let openMenuHeader = document.getElementById('js-open-menu');
    let getOpenMenuHeader = document.getElementById('mobile-nav');
    const bottomNavigation = document.getElementById("js-bottom-navigation");
    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    function handleBottomPosition(element, additionalBottom = 0) {
        if(isMobile){
            const bottomHeight = bottomNavigation.getBoundingClientRect().height + additionalBottom;
            element.style.bottom=`${bottomHeight}px`;
        }
    }
    function handleLeftPosition(element) {
        if (isMobile && bottomNavigation) {
            element.style.left = "20px";
        }
    }
    function handleRightPosition(element) {
        if (isMobile && bottomNavigation) {
            element.style.right = "0px";
        }
    }
    const observerChat = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === "childList") {
                const iframe = document.querySelector("iframe#chat-button");
                if (iframe) {
                    handleBottomPosition(iframe, 3);
                    handleRightPosition(iframe)
                    observerChat.disconnect();
                    break;
                }
            }
        }
    });
    const observerSms = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === "childList") {
                const buttomSms = document.querySelector(".ckrOyP.yotpo-smsbump-modal__content");
                if (buttomSms) {
                    handleBottomPosition(buttomSms, 10);
                    handleLeftPosition(buttomSms)
                    observerSms.disconnect();
                    break;
                }
            }
        }
    });
    observerChat.observe(document.body, {
        childList: true,
        subtree: true,
    });
    observerSms.observe(document.body, {
        childList: true,
        subtree: true,
    });
    openMenuHeader.addEventListener('click', openMenu);

    function openMenu() {
        if (getOpenMenuHeader) {
            getOpenMenuHeader.click();
        }
    }
});